import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const muaHangMenu: NavMenu = {
  title: 'Mua hàng',
  items: [
    {
      title: 'Đơn đặt hàng',
      items: [
        {
          title: 'Đơn hàng mua trong nước',
          icon: <AritoIcon icon={778} />,
          href: '/mua-hang/don-dat-hang/don-hang-mua-trong-nuoc'
        }
      ]
    },
    {
      title: 'Hóa đơn mua vào',
      items: [
        {
          title: 'Hóa đơn mua hàng trong nước',
          icon: <AritoIcon icon={778} />,
          href: '/mua-hang/hoa-don-mua-vao/hoa-don-mua-hang-trong-nuoc'
        },
        {
          title: 'Hóa đơn mua dịch vụ',
          icon: <AritoIcon icon={780} />,
          href: '/mua-hang/hoa-don-mua-vao/hoa-don-mua-dich-vu'
        },
        {
          title: 'Phiếu nhập chi phí mua hàng',
          icon: <AritoIcon icon={784} />,
          href: '/mua-hang/hoa-don-mua-vao/phieu-nhap-chi-phi-mua-hang'
        }
      ]
    },
    {
      title: 'Hoá đơn điều chỉnh/ trả lại',
      items: [
        {
          title: 'Phiếu nhập điều chỉnh giá hàng mua',
          icon: <AritoIcon icon={767} />,
          href: '/mua-hang/hoa-don-dieu-chinh-tra-lai/phieu-nhap-dieu-chinh-gia-hang-mua'
        },
        {
          title: 'Phiếu xuất trả lại nhà cung cấp',
          icon: <AritoIcon icon={766} />,
          href: '/mua-hang/hoa-don-dieu-chinh-tra-lai/phieu-xuat-tra-lai-nha-cung-cap'
        },
        {
          title: 'Hoá đơn dịch vụ trả lại nhà cung cấp',
          icon: <AritoIcon icon={766} />,
          href: '/mua-hang/hoa-don-dieu-chinh-tra-lai/hoa-don-dich-vu-tra-lai-nha-cung-cap'
        }
      ]
    },
    {
      title: 'Thanh toán tạm ứng',
      items: [
        {
          title: 'Phiếu thanh toán tạm ứng',
          icon: <AritoIcon icon={690} />,
          href: '/mua-hang/thanh-toan-tam-ung/phieu-thanh-toan-tam-ung'
        }
      ]
    },
    {
      title: 'Điều chỉnh/ Cấn trừ công nợ',
      items: [
        {
          title: 'Bút toán điều chỉnh giảm công nợ',
          icon: <AritoIcon icon={844} />,
          href: '/mua-hang/dieu-chinh-can-tru-cong-no/but-toan-dieu-chinh-giam-cong-no'
        },
        {
          title: 'Chứng từ phải trả khác, chứng từ bù trừ công nợ',
          icon: <AritoIcon icon={845} />,
          href: '/mua-hang/dieu-chinh-can-tru-cong-no/chung-tu-phai-tra-khac-chung-tu-bu-tru-cong-no'
        }
      ]
    },
    {
      title: 'Phân bổ tiền hàng trả cho các hoá đơn',
      icon: <AritoIcon icon={625} />,
      href: '/mua-hang/phan-bo-tien-hang-tra-cho-cac-hoa-don'
    },
    {
      title: 'Tất toán hoá đơn',
      icon: <AritoIcon icon={171} />,
      href: '/mua-hang/tat-toan-hoa-don'
    },
    {
      title: 'Báo cáo mua hàng',
      icon: <AritoIcon icon={331} />,
      items: [
        {
          title: 'Báo cáo tình trạng đơn hàng mua',
          icon: <AritoIcon icon={236} />,
          href: '/mua-hang/bao-cao-mua-hang/bao-cao-tinh-trang-don-hang-mua'
        },
        {
          title: 'Bảng kê hóa đơn mua hàng hóa, dịch vụ',
          icon: <AritoIcon icon={236} />,
          href: '/mua-hang/bao-cao-mua-hang/bang-ke-hoa-don-mua-hang'
        },
        {
          title: 'Bảng kê phiếu xuất trả lại nhà cung cấp',
          icon: <AritoIcon icon={42} />,
          href: '/mua-hang/bao-cao-mua-hang/bang-ke-phieu-xuat-tra-lai-nha-cung-cap'
        },
        {
          title: 'Báo cáo mua hàng nhóm theo 2 chỉ tiêu',
          icon: <AritoIcon icon={199} />,
          href: '/mua-hang/bao-cao-mua-hang/bao-cao-mua-hang-nhom-theo-2-chi-tieu'
        }
      ]
    },
    {
      title: 'Công nợ nhà cung cấp',
      icon: <AritoIcon icon={331} />,
      items: [
        {
          title: 'Sổ chi tiết công nợ theo nhà cung cấp',
          icon: <AritoIcon icon={860} />,
          href: '/mua-hang/cong-no-nha-cung-cap/so-chi-tiet-cong-no-theo-nha-cung-cap'
        },
        {
          title: 'Bảng cân đối phát sinh công nợ',
          icon: <AritoIcon icon={374} />,
          href: '/mua-hang/cong-no-nha-cung-cap/bang-can-doi-phat-sinh-cong-no'
        },
        {
          title: 'Báo cáo số dư công nợ',
          icon: <AritoIcon icon={35} />,
          href: '/mua-hang/cong-no-nha-cung-cap/bao-cao-so-du-cong-no'
        },
        {
          title: 'Sổ đối chiếu công nợ',
          icon: <AritoIcon icon={868} />,
          href: '/mua-hang/cong-no-nha-cung-cap/so-doi-chieu-cong-no'
        },
        {
          title: 'Bảng xác nhận công nợ',
          icon: <AritoIcon icon={236} />,
          href: '/mua-hang/cong-no-nha-cung-cap/bang-xac-nhan-cong-no'
        },
        {
          title: 'Sổ chi tiết công nợ nhiều nhà cung cấp',
          icon: <AritoIcon icon={137} />,
          href: '/mua-hang/cong-no-nha-cung-cap/so-chi-tiet-cong-no-nhieu-nha-cung-cap'
        }
      ]
    },
    {
      title: 'Công nợ hóa đơn mua',
      icon: <AritoIcon icon={769} />,
      items: [
        {
          title: 'Bảng kê công nợ theo hóa đơn',
          icon: <AritoIcon icon={776} />,
          href: '/mua-hang/cong-no-hoa-don-mua/bang-ke-cong-no-theo-hoa-don'
        },
        {
          title: 'Bảng kê chi tiết trả tiền cho các hoá đơn',
          icon: <AritoIcon icon={567} />,
          href: '/mua-hang/cong-no-hoa-don-mua/bang-ke-chi-tiet-tra-tien-cho-cac-hoa-don'
        }
      ]
    }
  ]
};
